import { LoadingButton } from "@mui/lab";
import { Alert, Box, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  clearPartitionState,
  createPartitionThunk,
  updatePartitionThunk,
} from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  number: yup
    .number()
    .required("Please enter partition number")
    .positive()
    .min(1),
  max_count: yup
    .number()
    .required("Please enter partition number")
    .positive()
    .min(1),
  notification_limit: yup.number().required().positive(),
  desc: yup.string(),
});
const CreateUpdatePartition = ({ tray_id, number, partition }) => {
  const formik = useFormik({
    initialValues: {
      number: partition ? partition.number : number ?? 1,
      max_count: partition?.max_count ?? 10,
      desc: partition?.desc ?? "",
      notification_limit: partition?.notification_limit ?? 0,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const _data = { ...data, tray: tray_id };
      if (partition) {
        dispatch(updatePartitionThunk({ id: partition.id, data: _data }));
      } else {
        dispatch(createPartitionThunk(_data));
      }
    },
  });
  const vendingState = useSelector((state) => state.vending);

  useEffect(() => {
    dispatch(clearPartitionState());
  }, []);
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          label="Enter partition number"
          variant="outlined"
          name="number"
          type="number"
          fullWidth
          sx={{ mt: 1 }}
          value={formik.values.number}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.number)}
          helperText={formik.errors.number}
          autoComplete="new-password"
          required
        />
        <TextField
          label="Max capacity"
          variant="outlined"
          name="max_count"
          type="number"
          fullWidth
          sx={{ mt: 2 }}
          value={formik.values.max_count}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.max_count)}
          helperText={formik.errors.max_count}
          autoComplete="new-password"
          required
        />
        <TextField
          label="Notification trigger number"
          variant="outlined"
          name="notification_limit"
          type="number"
          fullWidth
          sx={{ mt: 1 }}
          value={formik.values.notification_limit}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.notification_limit)}
          helperText={formik.errors.notification_limit}
          autoComplete="new-password"
          required
        />
        <TextField
          label="Description"
          variant="outlined"
          name="desc"
          type="text"
          fullWidth
          sx={{ mt: 2 }}
          value={formik.values.desc}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.desc)}
          helperText={formik.errors.desc}
          autoComplete="new-password"
          multiline
          rows={4}
        />
        {(vendingState.updatePartitionError ||
          vendingState.createPartitionError) && (
          <Alert sx={{ mt: 1 }} severity="error">
            Error occurred
          </Alert>
        )}
        {(vendingState.updatePartitionSuccess ||
          vendingState.createPartitionSuccess) && (
          <Alert sx={{ mt: 1 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          loading={
            vendingState.createPartitionLoading ||
            vendingState.updatePartitionLoading
          }
          variant="outlined"
          type="submit"
          sx={{ mt: 1 }}
        >
          {partition ? "Update" : "Create"}
        </LoadingButton>
      </form>
    </Box>
  );
};

export default CreateUpdatePartition;
